/*eslint-env jquery*/
import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Loading from '../_components/Shared/Loading'
import Slider from 'react-animated-slider'
import scrollToComponent from "react-scroll-to-component"
import 'react-animated-slider/build/horizontal.css'
import 'normalize.css'
import './slider-animations.css';
import './styles.css';

import RegisterForm from "./RegisterForm"
import PaymentForm from "./PaymentForm"
import ConnectToBankForm from "./ConnectToBankForm"
import CertificateForm from "./CertificateForm"
import ContactForm from "./ContactForm"
import Map from "./Map"

const content = [
  {
    title: ' ﺳﺎﻣﺎﻧﻪ ﺛﺒﺖ ﻧﺎم\n ﮐﻼس آﻣﻮزش اﺗﺎق اﺻﻨﺎف  ﺗﻬﺮان ',
    description:
      ' ﺟﻬﺖ ﺛﺒﺖ ﻧﺎم در ﮐﻼس ﻫﺎی آﻣﻮزش اﺻﻨﺎف ﺑﺮوی ﮔﺰﯾﻨﻪ ﺛﺒﺖ ﻧﺎم ﮐﻠﯿﮏ ﻧﻤﺎﯾﯿﺪ.\nﻫﻤﭽﻨﯿﻦ در ﺻﻮرت اﺳﺘﻌﻼم از وﺿﻌﯿﺖ ﮔﻮاﻫﯽ آﻣﻮزﺷﯽ ﺧﻮد ﺑﺮوی ﮔﺰﯾﻨﻪ اﺳﺘﻌﻼم ﮔﻮاﻫﯽ آﻣﻮزﺷﯽ ﮐﻠﯿﮏ ﻧﻤﺎﯾﯿﺪ.',
    button1: 'ثبت نام در کلاس',
    button2: 'پیگیری گواهی',
    image: '/slider/get-bg.jpg',
    img1: '/slider/banner-i-3.png',
    img2: '/slider/banner-i-4.png',
    img3: '/slider/banner-i-5.png'
  },
];
class HomePage extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      mode: 1,
      memberInfos: [
        // {"id":"7dbac4b7-2bc1-405f-9e66-f23b8263f6bb1","firstName":"امیر","lastName":"زرافشانی","nationalCode":"1381808484","fatherName":"نام پدر","idNumber":"123456","birthPlace":"تبریز","mobile":"09144100054","isicCode":"1234567890","tels":"021123456789","address":"adadas","birthDate":"2019-08-01T00:00:00","gender":0,"unionId":"69bcec56-945c-4597-8646-0df99af2f18d","union":null,"registerDate":"2019-08-20T14:19:20.221+04:30","memberStatus":0,"classId":"9ac463de-5ab1-4346-8639-69013214cc88","currentClass":null,"licenseDate":"0001-01-01T00:00:00","licenseNumber":null,"imagePath":"\\uploads\\2019\\8\\b0cff4d1-ff0c-4096-bd35-d5cce8d1a299.jpg","licenseFilePath":null,"trackId":1009,"senfNumber":"111","isIsargar":false}, {"id":"7dbac4b7-2bc1-405f-9e66-f23b8263f6bb","firstName":"امیر","lastName":"زرافشانی","nationalCode":"1381808484","fatherName":"نام پدر","idNumber":"123456","birthPlace":"تبریز","mobile":"09144100054","isicCode":"1234567890","tels":"021123456789","address":"adadas","birthDate":"2019-08-01T00:00:00","gender":0,"unionId":"69bcec56-945c-4597-8646-0df99af2f18d","union":null,"registerDate":"2019-08-20T14:19:20.221+04:30","memberStatus":0,"classId":"9ac463de-5ab1-4346-8639-69013214cc88","currentClass":null,"licenseDate":"0001-01-01T00:00:00","licenseNumber":null,"imagePath":"\\uploads\\2019\\8\\b0cff4d1-ff0c-4096-bd35-d5cce8d1a299.jpg","licenseFilePath":null,"trackId":1009,"senfNumber":"111","isIsargar":false}
      ],
    }

  }

  componentDidMount = () => {
    // new SmoothScroll(document, 150, 10);


    this.getData()
  }

  getData() {
    this.setState({ loading: false })
  }

  componentDidUpdate() {
    const { selectedItem } = this.state;
    if (selectedItem) {
      scrollToComponent(selectedItem, { align: "top" });
    }
  }

  onClick = itemId => {
    this.setState(state => ({ selectedItem: this[`${itemId}`] }));
  };

  onPayBtnClick = () => {
    this.setState(state => ({ mode: 2 }));
    this.onClick('reg')
  };

  render() {
    const { mode, loading } = this.state;
    return (
      <div className="home">
        <div className="container-fluid">
          <div className="row">
            <div className="logoWrapper">
              <img src="/slider/logo.png" alt="" />
            </div>
            <nav className="navbar">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="navbar-header">
                  <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-navbar-collapse" aria-expanded="false">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>

                </div>

                <div className="collapse navbar-collapse" id="bs-navbar-collapse">
                  <ul className="nav navbar-nav">
                    <li className="active"><a href="#">خانه <span className="sr-only">(current)</span></a></li>
                    <li><a href="#">ﺿﻮاﺑﻂ اﻧﺘﻈﺎﻣﯽ و ﺗﺮاﻓﯿﮑﯽ اﻣﺎﮐﻦ و ﺻﻨﻮف</a></li>
                    <li><a href="#">ﮐﺘﺎب ﺟﺎﻣﻊ واﺣﺪﻫﺎی ﺻﻨﻔﯽ </a></li>
                    <li><a href="#">ﻗﻮاﻧﯿﻦ ﮐﺎر و ﺗﺎﻣﯿﻦ اﺟﺘﻤﺎﻋﯽ </a></li>
                    <li><a href="#">ﻗﻮاﻧﯿﻦ ﻣﺎﻟﯿﺎﺗﯽ </a></li>
                    <li><a onClick={() => this.onClick('contact')}> ﺗﻤﺎس ﺑﺎ ﻣﺎ</a></li>
                  </ul>
                  <ul className="nav navbar-nav navbar-right pull-left">
                    <li><Link to="/login/members" className="loginBtn">ورود اعضاء</Link></li>
                  </ul>
                </div>
              </div>
            </nav>
            <Slider className="slider-wrapper">
              {content.map((item, index) => (
                <div
                  key={index}
                  className="slider-content"
                  style={{ background: `url('${item.image}') no-repeat center center` }}
                >
                  <div className="inner">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="captions">
                          <div className="texts">
                            <h1>{item.title}</h1>
                            <p>{item.description}</p>
                          </div>
                          <div className="btns">

                            <button className="btn1" onClick={() => this.onClick('reg')}>{item.button1}</button>
                            <button className="btn2" onClick={() => this.onClick('certificate')}>{item.button2}</button>

                          </div>
                        </div>

                      </div>
                      <div className="col-md-6">
                        <section className="sliderImages">
                          <img className="img2" src={item.img2} alt="" />
                          <img className="img1" src={item.img1} alt="" />
                          <img className="img3" src={item.img3} alt="" />
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="row" ref={ref => (this[`reg`] = ref)}>
          <div className="col-md-12">
            <div className="registeration">

              <div className="header">
                <h1>ثبت نام در کلاس آموزشی</h1>
                <p>
                  در ﺻﻮرﺗﯽ ﮐﻪ ﻗﺒﻼ ﺛﺒﺖ ﻧﺎم ﮐﺮده اﯾﺪ و ﻣﻮﻓﻖ ﺑﻪ ﭘﺮداﺧﺖ ﻧﺸﺪه اﯾﺪ
                    <br />
                  از ﮔﺰﯾﻨﻪ ﭘﺮداﺧﺖ ﻫﺰﯾﻨﻪ ﮐﻼس آﻣﻮزﺷﯽ اﺳﺘﻔﺎده ﻧﻤﺎﯾﯿﺪ
                    </p>
              </div>

              <div className="row clearfix spaced forms">
                <div className="col-md-6">
                  <img src="/home/fe-bg.png" alt="" />
                </div>

                <div className="col-md-6">
                  <img src="/home/ex-img.png" alt="" />
                </div>
              </div>

              <div className="formWrapper">
                <div className="regForm">
                  {
                    mode === 1 ?
                      <RegisterForm changeMode={(mode, memberInfos) => this.setState({ mode: mode, memberInfos: memberInfos })} />
                      : mode === 2 ?
                        <PaymentForm cancelPaymentBtn={() => this.setState({ mode: 1 })} changeMode={(mode, memberInfos) => this.setState({ mode: mode, memberInfos: memberInfos })} />
                        : mode === 3 ?
                          <ConnectToBankForm cancelPaymentBtn={() => this.setState({ mode: 1 })} memberInfos={this.state.memberInfos} />
                          : ''
                  }
                </div>
                {
                  mode === 1 || mode === 3 ?
                    <div className="pay">
                      <h4>ﻗﺒﻼ ﺛﺒﺖ ﻧﺎم ﮐﺮده ام</h4>
                      <h5>وﻟﯽ ﻣﻮﻓﻖ ﺑﻪ ﭘﺮداﺧﺖ آﻧﻼﯾﻦ ﻫﺰﯾﻨﻪ ﮐﻼس ﻧﺸﺪه ام </h5>
                      <button className="payBtn pull-left" onClick={() => this.onPayBtnClick()}>ﭘﺮداﺧﺖ ﻫﺰﯾﻨﻪ ﮐﻼس</button>
                    </div>
                    : ""
                }
              </div>

            </div>
          </div>
        </div>
        <div className="row clearfix certificate grey" ref={ref => (this[`certificate`] = ref)}>
          <div className="col-md-6">
            <CertificateForm />
          </div>
          <div className="col-md-6">
            <img src="/home/testimonial.png" alt="" />
          </div>

        </div>

        <div className="row clearfix contacts" ref={ref => (this[`contact`] = ref)}>
          <div className="col-md-3 col-md-offset-1">
            <Map center={[35.705103, 51.430312]} zoom={15} />
            <br />
            <div className="header">
              <p>
                ﺧﯿﺎﺑﺎن ﺷﺮﯾﻌﺘﯽ ﺗﻘﺎﻃﻊ ﻣﻠﮏ ﺳﺎﺧﺘﻤﺎن اﺗﺎق اﺻﻨﺎف ﺗﻬﺮان
                <br />
                ﺗﻠﻔﻦ ﺗﻤﺎس : 85543248 - 85543255 - 85543225
                </p>
            </div>
          </div>
          <div className="col-md-5">
            <ContactForm />
          </div>
          <div className="col-md-3">
            <img className="contactsImage" src="/home/banner-i-10.png" alt="" />
          </div>

        </div>

        <div className="row clearfix footer text-center">
          <p>
            <a href="http://ecoat.ir/">فنآوری و اطلاعات اتاق اصناف تهران</a>
          </p>
          <p>
            <a href="http://rahbord.org/">شرکت ایده پردازان هوشمند راهبرد</a>
          </p>
          <p>
            <Link to="/login" style={{fontSize:12}}>(ورود به سیستم)</Link>
          </p>
        </div>


      </div >
    );
  }
}

function SmoothScroll(target, speed, smooth) {

  var tar = target;
  if (target === document)
    target = (document.scrollingElement
      || document.documentElement
      || document.body.parentNode
      || document.body) // cross browser support for document scrolling

  var moving = false
  var pos = target.scrollTop
  var frame = target === document.body
    && document.documentElement
    ? document.documentElement
    : target // safari is the new IE

  target.addEventListener('mousewheel', scrolled, { passive: true })
  target.addEventListener('DOMMouseScroll', scrolled, { passive: true })

  function scrolled(e) {

    // $.each($(event.target).parent().attributes, function() {
    //   // this.attributes is not a plain object, but an array
    //   // of attribute nodes, which contain both the name and value
    //   if(this.specified) {
    //     console.log(this.name, this.value);
    //   }
    // });

    if (e.target.closest(".list")) {
      // target = (e.target.closest( ".list" ));
      return false;
    } else {
      // target = (document.scrollingElement
      //   || document.documentElement
      //   || document.body.parentNode
      //   || document.body)
    }

    e.preventDefault(); // disable default scrolling

    var delta = normalizeWheelDelta(e)

    pos += -delta * speed
    pos = Math.max(0, Math.min(pos, target.scrollHeight - frame.clientHeight)) // limit scrolling

    if (!moving) update()
  }

  function normalizeWheelDelta(e) {
    if (e.detail) {
      if (e.wheelDelta)
        return e.wheelDelta / e.detail / 40 * (e.detail > 0 ? 1 : -1) // Opera
      else
        return -e.detail / 3 // Firefox
    } else
      return e.wheelDelta / 120 // IE,Safari,Chrome
  }

  function update() {
    moving = true

    var delta = (pos - target.scrollTop) / smooth

    target.scrollTop += delta

    if (Math.abs(delta) > 0.5)
      requestFrame(update)
    else
      moving = false
  }

  var requestFrame = function () { // requestAnimationFrame cross browser
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (func) {
        window.setTimeout(func, 1000 / 50);
      }
    );
  }()
}


function mapStateToProps(state) {
  const { users, authentication } = state;
  const { user } = authentication;
  return {
    user,
    users
  };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };
